<tax-modal-header data-qa-block="payment-method-header">{{
  'account_payment-methods.title' | translate
}}</tax-modal-header>

<tax-modal-content data-qa-block="payment-method-content" class="payment-method-list">
  <button
    *ngFor="let method of paymentMethods"
    type="button"
    data-qa-button="select-payment-method"
    class="payment-method"
    [class.selected]="activePaymentMethod?.title === method.title"
    [disabled]="activePaymentMethod?.title === method.title"
    (click)="selectPaymentMethod(method)"
  >
    <svg-icon [key]="method.icon"></svg-icon>
    <span data-qa="payment-method-title" class="payment-method-title">
      {{ method.title | translate }}
    </span>
  </button>
</tax-modal-content>

<tax-modal-footer>
  <button data-qa-button="continue" class="button_blue ui-kit-align-right" (click)="openPayment()">
    {{ 'button.continue' | translate }}
  </button>
</tax-modal-footer>
